import { Link, createFileRoute } from "@tanstack/react-router"
import { operators } from "@/constants/operators"
import { getPrizesClient } from "@/queries/clients"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { LoadingSpinner } from "@/components/ui/loading"
import { Separator } from "@/components/ui/separator"
import { useEffect, useState } from "react"
import { useMutation, useQuery } from "@tanstack/react-query"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { useForm } from "react-hook-form"
import { purchasePrize } from "@/queries/prizes"
import { toast } from "sonner"
import { PrizesType, type Prize } from "@/types"
import { useStore } from "@tanstack/react-store"
import userStore from "@/stores/user-store"
import { Camera, Copy, ExternalLink } from "lucide-react"
import PrizeCard from "@/components/prize-card"
import DescriptionSection from "@/components/description-section"

export const Route = createFileRoute("/client/prizes/")({
  component: ClientPrizes,
})




function ClientPrizes() {
  const [prizes, setPrizes] = useState<Array<Prize>>([])
  const [tags, setTags] = useState<Array<any>>([])
  const [buyModal, setBuyModal] = useState<boolean>(false)
  const [selectedPrice, setSelectedPrice] = useState<Prize | null>()
  const [code, setCode] = useState('')
  const [selectedTag, setSelectedTag] = useState('all')

  const { points } = useStore(userStore)

  const setPoint = (points: any) => {
    userStore.setState((state) => ({ ...state, points }))
  }

  const getClientPrizes = useQuery({
    queryFn: () => getPrizesClient(),
    queryKey: ["prizes", "client"],
  })

  useEffect(() => {
    if (getClientPrizes.data) {
      const data = getClientPrizes.data.data.data
      
      if (data) {
        const allTags:any = []
        data.map((d:any)=> 
        {
          allTags.push(...d.tags)
        })
        console.log(allTags)
        const unique = Object.values(
          allTags.reduce((acc:any, item:any) => {
            acc[item.id] = item;
            return acc;
          }, {} as Record<number, any>)
        );
        setTags(unique)
        setPrizes(data)
      }
    }
  }, [getClientPrizes.data])

  const handleBuyPrize = (prize: Prize) => {
    setBuyModal(true)
    setSelectedPrice(prize)
  }

  const purchaseMutation = useMutation({
    mutationFn: (mobile?: string) => purchasePrize(selectedPrice?.id, mobile),
    mutationKey: ["prize", "purchase", selectedPrice?.id],
    onSuccess({data}) {
      console.log(data)
      toast.success("جایزه با موفقیت دریافت شد")
      if (selectedPrice?.type === 'discount') {
        setCode(data.message)
      } else {

        setBuyModal(false)
        if (selectedPrice) {
          setPoint(points - Number(selectedPrice?.point))
        }
      }
      },
    onError() {
      toast.error("خطا در دریافت جایزه")
      setBuyModal(false)
    },
  })

  const operatorRegex = {
    1: new RegExp("^(0?91)|^(0?99)"),
    2: new RegExp(
      "^(0?93)|^(0?94)|^(0?900)|^(0?901)|^(0?902)|^(0?903)|^(0?904)|^(0?905)"
    ),
    3: new RegExp("^(0?92)"),
    4: new RegExp("^(0?9991)"),
    5: new RegExp("^(0?998)"),
  }

  const purchaseForm = useForm<{ mobile: string} >({
    mode: "onChange",
  })

  const onSubmit = (values: { mobile: string} ) => {
    console.log(values.mobile)
    purchaseMutation.mutate(values.mobile)
  }

  return (
    <>
      <Dialog open={buyModal} onOpenChange={(open) => setBuyModal(open)}>
        <DialogContent>
          <DialogHeader>
            {code ? <DialogTitle>دریافت جایزه</DialogTitle> :<DialogTitle>خرید جایزه</DialogTitle>}
          </DialogHeader>
          {selectedPrice && <div className="grid grid-cols-2 gap-2 pt-4">
          <div className={`size-20 rounded-full ${selectedPrice.images && selectedPrice.images.length < 1 ? 'bg-accent' : ''} flex justify-center items-center overflow-hidden col-span-2 mx-auto`}>
            {selectedPrice.images && selectedPrice.images.length > 0 ? (
              <>
                <img
                  src={selectedPrice.images[0].url}
                  alt={selectedPrice.images[0].name}
                  className="size-20 object-contain"
                />
              </>
            ) : (
              <>
                <Camera className="size-10" />
              </>
            )}
          </div>
          <div className="text-lg font-bold col-span-2 text-center">
            {selectedPrice.name}
          </div>
          {/* {selectedPrice.type != "discount" ? (
            <>
              <span>ارزش : </span>
              <span>{Intl.NumberFormat("fa-ir").format(selectedPrice.price)} ریال</span>
            </>
          ) : (
            ""
          )} */}
          <span>امتیاز مورد نیاز: </span>
          <span>{Intl.NumberFormat("fa-ir").format(selectedPrice.point)}</span>
          {selectedPrice.type != "discount" && selectedPrice.type !== "physical" ? (
            <>
              <span>اپراتور: </span>
              <span>
                {operators.find((o) => o.id === selectedPrice.operator_id)?.title}
              </span>
            </>
          ) : (
            ""
          )}
          <span>نوع جایزه:</span>
          <span>{PrizesType[selectedPrice.type]}</span>
          </div>}
          <div className="flex flex-col gap-2">
            {selectedPrice?.description && <Alert>
              <AlertTitle>توضیحات</AlertTitle>
              <AlertDescription>
                <DescriptionSection description={selectedPrice?.description} gradientClassName="from-background"/>
              </AlertDescription>
              </Alert>}
            {selectedPrice?.type === 'discount' ? code != '' ? <>
              <Label>
                کد شما : 
              </Label>
                <div className="text-xl font-bold">
                  {code}
                </div>
                <div className="flex gap-2">

                <Button className="flex-1/2 flex gap-1" onClick={() => {
                  navigator.clipboard.writeText(code)
                  toast.success('کد با موفقیت کپی شد')
                }}>
                  <Copy />
                  کپی کردن
                </Button>
                <a target="_blank" href={selectedPrice.url?.includes("://") ? selectedPrice.url : `https://${selectedPrice.url}`}>

                <Button className="flex-1/2 flex gap-1" variant="outline" >
                  <ExternalLink />
                  رفتن به سایت
                </Button>
                </a>
                  </div>

                  <p className="font-bold">کد شما همیشه در تاریخچه قابل دسترس خواهد بود</p>

                <DialogFooter>
                  <Button  variant="secondary"
                      type="button"
                      onClick={() => setBuyModal(false)}>
                    بستن
                  </Button>
                </DialogFooter>

            </> : <>
            <p>یعد از تایید کد تخفیف برای شما به نمایش در خواهد آمد و همچنین در قسمت تاریخچه جوایز دردسترس خواهد بود</p>
            <DialogFooter className="flex gap-3 mt-2">
                    <Button
                      variant="secondary"
                      type="button"
                      onClick={() => setBuyModal(false)}
                    >
                      لغو
                    </Button>
                    <Button
                      onClick={() => purchaseMutation.mutate(undefined)}
                      disabled={selectedPrice.point > points}
                      isLoading={purchaseMutation.isPending}
                    >
                      خرید
                    </Button>
                  </DialogFooter>
            
            </>  :  selectedPrice?.type === "physical"  ? (
              <>
                آیا از خرید این جایزه مطمئن هستید ؟ در صورت خرید این جایزه باید
                توسط ادمین به تایید برسد!
                <DialogFooter className="flex gap-3 mt-2">
                  <Button
                    variant="secondary"
                    type="button"
                    onClick={() => setBuyModal(false)}
                  >
                    لغو
                  </Button>
                  <Button
                    type="submit"
                    isLoading={purchaseMutation.isPending}
                    disabled={selectedPrice.point > points}
                    onClick={() => purchaseMutation.mutate(undefined)}
                  >
                    خرید
                  </Button>
                </DialogFooter>
              </>
            ) : selectedPrice?.type == 'increase_prize' ? <>
              <p>به اندازه مبلغ مشخص شده اعتبار شما افزایش خواهد یافت</p>
              <DialogFooter className="flex gap-3 mt-2">
                  <Button
                    variant="secondary"
                    type="button"
                    onClick={() => setBuyModal(false)}
                  >
                    لغو
                  </Button>
                  <Button
                    type="submit"
                    isLoading={purchaseMutation.isPending}
                    disabled={selectedPrice.point > points}
                    onClick={() => purchaseMutation.mutate(undefined)}
                  >
                    خرید
                  </Button>
                </DialogFooter>
            </> : (
              <>
                <Alert variant="default">
                  <AlertTitle>نحوه خرید</AlertTitle>
                  <AlertDescription>
                    برای خرید این جایزه شماره مورد نظر خود را وارد کنید...
                  </AlertDescription>
                </Alert>
                <form onSubmit={purchaseForm.handleSubmit(onSubmit)}>
                  <div className="flex flex-col gap-2">
                    <Label>شماره همراه</Label>
                    <Input
                      {...purchaseForm.register("mobile", {
                        required: {
                          value: true,
                          message: "وارد کردن شماره موبایل الزامی است",
                        },
                        pattern: {
                          value: selectedPrice?.operator_id
                            ? operatorRegex[selectedPrice.operator_id]
                            : /[0-9]/g,
                          message: `شماره موبایل وارد شده باید حتما ${operators?.find((operator: any) => operator.id === selectedPrice?.operator_id)?.title} باشد`,
                        },
                      })} disabled={(selectedPrice?.point || 0) > points} dir="ltr" type="tel" />
                    {purchaseForm?.formState?.errors?.mobile && (
                      <div className="text-xs text-destructive">
                        {purchaseForm?.formState?.errors?.mobile?.message}
                      </div>
                    )}
                  </div>
                  <DialogFooter className="flex gap-3 mt-2">
                    <Button
                      variant="secondary"
                      type="button"
                      onClick={() => setBuyModal(false)}
                    >
                      لغو
                    </Button>
                    <Button
                      type="submit"
                      isLoading={purchaseMutation.isPending}
                      disabled={(selectedPrice?.point || 0) > points}
                    >
                      خرید
                    </Button>
                  </DialogFooter>
                </form>
              </>
            )}
          </div>
        </DialogContent>
      </Dialog>
        <div className="flex flex-row items-center justify-between">
          <h1 className="text-2xl font-bold">جوایز</h1>
          <div className="flex gap-2">
            <Link to="/client/prizes/history">
              <Button variant="secondary">تاریخچه جوایز</Button>
            </Link>
            
            <Link to="/">
              <Button>بازگشت</Button>
            </Link>
          </div>
        </div>
        <Separator className="my-4" />
          <Alert className="flex justify-between items-center bg-card">
            <span>

            <span className="font-bold">
            امتیاز شما :
            </span>
            
             {Intl.NumberFormat("fa-ir").format(points)}
            </span>

            {/* <Link to="/point/history">
              <Button>تاریخچه امتیازات دریافت شده</Button>
            </Link> */}

          </Alert>
          {getClientPrizes.isLoading ? (
            <LoadingSpinner />
          ) : prizes.length < 1 ? (
            <div className="h-52 w-full flex justify-center items-center">
              <p>هیچ جایزه ای وجود ندارد ...</p>
            </div>
          ) : (
            <>
            <div className="overflow-x-auto flex gap-2 my-2">
              <Button onClick={() => setSelectedTag('all')} variant={selectedTag == 'all' ? 'default' : 'outline'}>
                همه
              </Button>
              {tags.map(tag => (<>
                <Button onClick={() => setSelectedTag(tag.id)} variant={selectedTag == tag.id ? 'default' : 'outline'}>
                  {tag.name.en}
                </Button>
              </>))}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 mt-4">
              {prizes.sort((a, b) => {
                if (a.point <= points && b.point > points) {
                  return -1
                } else if (a.point > points && b.point <= points) {
                  return 1
                } else {
                  return a.point - b.point
                }
              }).filter(o=> {
                if (selectedTag == 'all') {
                  return true
                } else {
                  const hasTag = o.tags.filter((tag:any) => tag.id == selectedTag).length

                  if (hasTag > 0) {
                    return true
                  }
                  return false                   
                }
                return false
              }).map((prize) => (
                <PrizeCard prize={prize} onClick={handleBuyPrize}/>
              ))}
            </div>
            </>
          )}
    </>
  )
}
